export const BUILD_VERSION = "v2026.07.11-logo-blend";
export const BUILD_TIMESTAMP = "2026-07-11T08:00:00Z";
